export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
            <i className="ri-information-line"></i>
            了解我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
            关于香香漫画
          </h2>

          <div className="text-left space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            <p>
              香香漫画成立于2023年，是一个专注于<strong className="text-foreground-800">韩漫免费阅读</strong>的综合平台。我们热爱漫画文化，致力于为中文读者提供最优质的韩漫阅读体验。从上线至今，平台已收录超过三千部<strong className="text-foreground-800">韩漫全集</strong>，涵盖恋爱、奇幻、动作、悬疑、穿越重生、宫廷斗争等全部热门类型。
            </p>
            <p>
              我们深知追更等待的焦急，因此建立了高效的同步更新机制，确保<strong className="text-foreground-800">最新韩漫</strong>在韩国官方发布后第一时间同步上线。独创的<strong className="text-foreground-800">下拉式</strong>阅读模式，专为手机用户优化设计，让你随时随地畅享沉浸式漫画阅读。
            </p>
            <p>
              香香漫画坚持<strong className="text-foreground-800">完全免费</strong>的运营理念，通过广告收入维持平台运转，不设任何付费墙或会员门槛。我们相信，好看的韩漫应该被更多读者看到。无论你是资深韩漫迷还是刚入坑的新读者，这里都是你的<strong className="text-foreground-800">在线阅读</strong>家园。追更必备，韩漫全集尽在香香漫画。
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
            {[
              { value: '3,200+', label: '韩漫作品' },
              { value: '50万+', label: '忠实读者' },
              { value: '99.9%', label: '在线率' },
              { value: '15+', label: '内容分类' },
            ].map((item) => (
              <div key={item.label} className="bg-background-100 rounded-xl p-4">
                <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">
                  {item.value}
                </div>
                <div className="text-xs text-foreground-500 mt-1">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}